export const INITIAL_MAP_ZOOM = 12;
export const SELECTED_ADDRESS_MAP_ZOOM = 16;

export const ZOOM_STEP = 1;
